<template>
    <!-- <iframe class="yingshi-player"
            :src='url'
            allowFullScreen
    >
    </iframe> -->
    <div>
        <div id='video-container' class="yingshi-player"></div>
    </div>
    
</template>

<script>
import EZUIKit from "ezuikit-js";
    export default {
        components:{},
        props: ['sn', 'accessToken'],
        data() {
            return {autoplay: 1}
        },
        computed: {
            url() {
                return 'https://open.ys7.com/ezopen/h5/iframe_se' +
                    `?url=ezopen://open.ys7.com/${this.sn}/1.live&autoplay=${this.autoplay}&accessToken=${this.accessToken}`
            }
        },
        created(){
            (window).EZUIKit = EZUIKit;
        },
        mounted(){
            this.open()
        },
        methods:{
            open() {
                this.playr = new EZUIKit.EZUIKitPlayer({
                    id: 'video-container',
                    accessToken: this.accessToken,
                    apiDomain: ``,
                    template: 'voice',
                    audio: 0,
                    plugin: [`talk`],
                    isReliesReady: true,
                    url: `ezopen://open.ys7.com/${this.sn}/1.live`,
                });
            }
        },
        watch:{}
    }
</script>

<style lang="less" scoped>
    .yingshi-player {
        width: calc(100vw);
        /*height: calc(50vw );*/
        height: calc(50vw + 70px );
        display: flex;
        flex-direction: column;
        &>iframe {
            height: 50px;
            flex-grow: 1;
        }
    }
</style>